import React from 'react';
import { connect } from 'react-redux';

import DocumentsTables from '../document/table/DocumentsTables.jsx';
import DocumentEntity from '../../../../../shared/src/entity/DocumentEntity';
import CategoryEntity from '../../../../../shared/src/entity/CategoryEntity';

const BookPanel = ({ documents, activeCategory }) => (
  <div className="main-content">
    <div className="main-content-table">
      <DocumentsTables documents={documents.filter(doc => doc.categories.find(cat => cat.id === activeCategory.id))}/>
    </div>
  </div>
);

BookPanel.propTypes = {
  /*
   * The list containing all the documents present browser side.
   */
  documents: React.PropTypes.arrayOf(
    React.PropTypes.shape(DocumentEntity.shape),
  ).isRequired,
  /*
   * The ID of the active category.
   */
  activeCategory: React.PropTypes.shape(CategoryEntity.shape).isRequired,
};


const mapStateToProps = ({ documents: { data: documents, activeCategory } }) => ({
  documents,
  activeCategory,
});

export default connect(mapStateToProps)(BookPanel);



// WEBPACK FOOTER //
// ./book/src/commons/components/book/BookPanel.jsx